import { SignUp } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sign-up")({
  component: SignUpPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      redirect_url: (search.redirect_url as string) || "/",
    };
  },
});

function SignUpPage() {
  const { redirect_url } = Route.useSearch();

  return (
    <div className="flex items-center justify-center min-h-screen px-4 py-8 bg-[var(--bg-default)]">
      <SignUp
        appearance={{
          elements: {
            rootBox: "mx-auto",
            card: "shadow-lg bg-[var(--bg-modal)] border border-[var(--stroke-field)]",
          },
        }}
        signInUrl="/sign-in"
        forceRedirectUrl={redirect_url}
      />
    </div>
  );
}
